import { TenantUsuarioDetalhe } from "core/features/tenants/typings/tenant";
import { useMutation } from "react-query";
import http from "infra/http";

function useSaveTenantUsuario(tenantId: string, id?: string) {
  return useMutation(
    "/v1/tenants/id/usuarios/usuarioId",
    (data: TenantUsuarioDetalhe) =>
      id
        ? http.put(`/v1/tenants/${tenantId}/usuarios/${id}`, data)
        : http.post(`/v1/tenants/${tenantId}/usuarios`, data),
    { retry: false }
  );
}

export default useSaveTenantUsuario;
